import { Clock, Wrench, HandHeart, CheckCircle2, ArchiveX, BellRing, Sparkles } from "lucide-react";

const META = {
  new: { label: "New", icon: Sparkles, color: "var(--ta-primary)", bg: "var(--ta-accent)" },
  in_progress: { label: "In progress", icon: Wrench, color: "#8A5A00", bg: "#FFF3D6" },
  waiting_on_customer: { label: "We've got it", icon: HandHeart, color: "var(--ta-secondary)", bg: "#FCE6DE" },
  completed: { label: "Completed", icon: CheckCircle2, color: "var(--ta-success)", bg: "var(--ta-success-bg)" },
  dismissed: { label: "Hidden", icon: ArchiveX, color: "var(--ta-text-secondary)", bg: "var(--ta-surface-alt)" },
  snoozed: { label: "Snoozed", icon: BellRing, color: "var(--ta-primary-light)", bg: "var(--ta-accent)" },
};

export default function StatusBadge({ status, testId, size = "md" }) {
  const meta = META[status] || META.new;
  const Icon = meta.icon || Clock;
  const sm = size === "sm";
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-widest ${
        sm ? "text-[10px] px-2.5 py-1" : "text-[11px] px-3 py-1.5"
      }`}
      style={{ background: meta.bg, color: meta.color }}
    >
      <Icon size={sm ? 12 : 14} strokeWidth={2.4} />
      {meta.label}
    </span>
  );
}
